import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalController, IonicModule } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { ButtonComponent } from 'src/app/components/button/button.component';

@Component({
  selector: 'app-update-modal',
  standalone: true,
  imports: [CommonModule, IonicModule, ButtonComponent],
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.scss']
})
export class UpdateModalComponent {
  @Input() currentVersion?: string;
  @Input() minVersion?: string;
  @Input() apiVersion?: string;

  constructor(
    private modalController: ModalController,
    private platform: Platform
  ) {}

  async updateApp() {
    // Abrir la tienda correspondiente según la plataforma
    if (this.platform.is('ios')) {
      window.location.href = 'itms-apps://apps.apple.com/pa/app/drink-hopping-partners/id6743446568';
    } else if (this.platform.is('android')) {
      window.location.href = 'market://details?id=com.drinkhopping.manager';
    }
  }

  dismiss() {
    // No permitir cerrar el modal sin actualizar
    // this.modalController.dismiss();
  }
}
